import gameRoleSelect from './game-role-select';
import pacakgeClaimRecords from './package-claim-records';
import PackageClaimRedPacketRecords from './package-claim-redpacket-records';
import giftRewardRecords from './gift-reward-records';
import GiftComponent from './gift-component';
import rechargeRecord from './recharge-record';
import userLoginComponent from './user-login-component';
import Apis from './apis';
import { DialogPlugin, default as CeibaBaseDialog } from './ceiba-base-dialog';
export default {
  gameRoleSelect,
  pacakgeClaimRecords,
  PackageClaimRedPacketRecords,
  Apis,
  DialogPlugin,
  CeibaBaseDialog,
  GiftComponent,
  rechargeRecord,
  giftRewardRecords,
  userLoginComponent,
};
